import * as moment from "moment";
import * as React from "react";

interface IProps {
    mainCard?: any
}

export class MigratedCreditCardSection extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    public render() {
        if (this.props.mainCard) {
            return (
                <div className="mt-3 credit-card-section" id={`card-main`}>
                    <div>
                        <div id="cardType" className="font-weight-bold mb-2">
                            {this.renderCardName(this.props.mainCard)} ending in <span id="cardNumber">{this.props.mainCard.number.split('******')[1]}</span>
                        </div>
                    </div>

                    <div className="mt-1">
                        <span className="font-weight-bold">Expiry date: </span>
                        <span id="cardExpiryDate">
                            {moment.monthsShort(this.props.mainCard.expirtyMonth - 1)} '{this.props.mainCard.expirtyYear}
                        </span>
                    </div>
                </div>
            );
        } else {
            return (<div>No cards added to account</div>);
        }
    }

    private renderCardName(card: any): string {
        if (card.type.includes("VISA")) {
            return "Visa";
        }
        if (card.type.includes("MASTERCARD")) {
            return "Mastercard";
        }
        return "";
    }
}
